export const Marquee = () => {
  const text =
    "Steel Windows · Steel Doors · Luxury Entrances · Casement · Awning · Bifold · Pivot · Fixed · Tilt-Turn · Hardware · ";
  return (
    <section
      data-testid="marquee-section"
      className="relative overflow-hidden border-y border-white/10 bg-[#0a0a0c] py-5"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((k) => (
          <span
            key={k}
            className="font-tech whitespace-nowrap px-4 text-[11px] uppercase tracking-[0.4em] text-[#c6a87c]/70"
          >
            {text.repeat(3)}
          </span>
        ))}
      </div>
    </section>
  );
};
